import React, { useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const InformeAusencias = () => {
  const [formData, setFormData] = useState({
    sede: '',
    tipo: '',
    fechaDesde: '',
    fechaHasta: '',
  });

  const [resultados, setResultados] = useState([]);
  const [resumenTabla, setResumenTabla] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orden, setOrden] = useState({ campo: '', direccion: 'asc' });
  const [ordenResumen, setOrdenResumen] = useState({ campo: '', direccion: 'asc' });
 const [veoConsultasAusencias,setVeoConsultasAusencias]=useState("false")
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const abreDatas = (dni) => {
    window.open('/CadeteEdit?dni=' + dni, '_blank');
  };

  const handleBuscar = async () => {
    setLoading(true);
    try {
      const token = btoa(`${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`);
      const client = axios.create({
        baseURL: `${process.env.REACT_APP_BASEURL}NCadetes/obtieneTodasLasAusencias`,
        headers: {
          Authorization: `Basic ${token}`,
          'Content-Type': 'application/json'
        },
      });

      const consulta = {
        sede: formData.sede || undefined,
        tipo: formData.tipo || undefined,
        fechaDesde: formData.fechaDesde || undefined,
        fechaHasta: formData.fechaHasta || undefined,
      };

      const response = await client.post('/', consulta);
      const datos = response.data.Ausencias || [];
      setResultados(datos);

      // Construir resumen
      const resumen = {};
      const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

      datos.forEach(aus => {
        const fechaObj = new Date(aus.fecha);
        const fecha = fechaObj.toISOString().split('T')[0];
        const dia = diasSemana[fechaObj.getDay()];
        const promocion = aus.cadete?.Promocions[0]?.nombre || 'Sin promoción';
        const sede = aus.cadete?.cadeteSede || 'Sin sede';
        const clave = `${fecha}|${promocion}|${sede}`;

        if (!resumen[clave]) {
          resumen[clave] = {
            Fecha: fecha,
            Día: dia,
            Promoción: promocion,
            Sede: sede,
            Cantidad: 0,
          };
        }

        resumen[clave].Cantidad++;
      });

      setResumenTabla(Object.values(resumen));
    } catch (error) {
      console.error('Error al consultar:', error);
      setResultados([]);
      setResumenTabla([]);
    } finally {
      setLoading(false);
    }
  };

  const exportarExcel = () => {
    // Detalle
    const data = resultados.map((ausencia, index) => ({
      Nro: index + 1,
      DNI: ausencia.cadeteDni,
      Apellido: ausencia.cadete?.cadeteApellido,
      Nombre: ausencia.cadete?.cadeteNombre,
      Sede: ausencia.cadete?.cadeteSede,
      Promocion: ausencia.cadete?.Promocions[0]?.nombre,
      Estado: ausencia.estado,
      Fecha: ausencia.fecha,
      Observacion: ausencia.observacion || '',
      UsuarioCarga: ausencia.usuarioId || '',
    }));

    // Resumen
    const resumenData = resumenTabla.map((r, i) => ({
      Nro: i + 1,
      Cantidad: r.Cantidad,
      Promoción: r.Promoción,
      Sede: r.Sede,
      Día: r.Día,
      Fecha: r.Fecha
    }));

    const wb = XLSX.utils.book_new();
    const detalleSheet = XLSX.utils.json_to_sheet(data);
    const resumenSheet = XLSX.utils.json_to_sheet(resumenData);

    XLSX.utils.book_append_sheet(wb, detalleSheet, "Detalle Ausencias");
    XLSX.utils.book_append_sheet(wb, resumenSheet, "Resumen Diario");

    const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const archivo = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(archivo, 'ausencias_informe_' + new Date().toLocaleString() + ".xlsx");
  };

  const ordenarResultados = campo => {
    const direccion = orden.campo === campo && orden.direccion === 'asc' ? 'desc' : 'asc';
    const sorted = [...resultados].sort((a, b) => {
      const aVal = extraerValor(a, campo);
      const bVal = extraerValor(b, campo);
      if (aVal < bVal) return direccion === 'asc' ? -1 : 1;
      if (aVal > bVal) return direccion === 'asc' ? 1 : -1;
      return 0;
    });
    setOrden({ campo, direccion });
    setResultados(sorted);
  };

  const ordenarResumen = campo => {
    const direccion = ordenResumen.campo === campo && ordenResumen.direccion === 'asc' ? 'desc' : 'asc';
    const sorted = [...resumenTabla].sort((a, b) => {
      const aVal = a[campo] || '';
      const bVal = b[campo] || '';
      if (aVal < bVal) return direccion === 'asc' ? -1 : 1;
      if (aVal > bVal) return direccion === 'asc' ? 1 : -1;
      return 0;
    });
    setOrdenResumen({ campo, direccion });
    setResumenTabla(sorted);
  };

  const extraerValor = (obj, campo) => {
    switch (campo) {
      case 'cadeteDni': return obj.cadeteDni || '';
      case 'apellido': return obj.cadete?.cadeteApellido || '';
      case 'nombre': return obj.cadete?.cadeteNombre || '';
      case 'sede': return obj.cadete?.cadeteSede || '';
      case 'promocion': return obj.cadete?.Promocions[0]?.nombre || '';
      case 'estado': return obj.estado || '';
      case 'fecha': return new Date(obj.fecha).getTime();
      default: return '';
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-xl font-semibold mb-4 btn btn-primary" onClick={()=>setVeoConsultasAusencias(!veoConsultasAusencias)}>Consulta de Ausencias</h1>
{veoConsultasAusencias?<>      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <select
  name="sede"
  value={formData.sede}
  onChange={handleChange}
  className="p-2 border rounded"
>
  <option value="">-- Todas --</option>
  <option value="Rosario">Rosario</option>
  <option value="Recreo">Recreo</option>
 
</select>
       <select
  name="tipo"
  value={formData.tipo}
  onChange={handleChange}
  className="p-2 border rounded"
>
  <option value="">-- Todas --</option>
  <option value="ACA">ACA</option>
  <option value="ACA guardia">ACA guardia</option>
  <option value="ASA guardia">ASA guardia</option>
  <option value="ASA">ASA</option>
  <option value="Tardanza">Tardanza</option>
  <option value="Pase de Salida">Pase de Salida</option>
</select>
        <input type="date" name="fechaDesde" value={formData.fechaDesde} onChange={handleChange} className="p-2 border rounded" />
        <input
          type="date"
          name="fechaHasta"
          value={formData.fechaHasta}
          onChange={handleChange}
          max={new Date().toISOString().split('T')[0]}
          className="p-2 border rounded"
        />
      </div>

      <div className="flex gap-4 mb-4">
        <button onClick={handleBuscar} className="btn btn-primary">
          {loading ? 'Buscando...' : 'Buscar'}
        </button>
        {resultados.length > 0 && (
          <button onClick={exportarExcel} className="btn btn-success">
            Descargar Excel
          </button>
        )}
      </div>

      {loading && <div className="text-center mt-6">
        <span className="animate-pulse text-blue-600 font-semibold">Cargando resultados...</span>
      </div>}

      {!loading && resultados.length > 0 && (
        <>
          <p className="text-sm text-gray-700 mb-2">Se encontraron <strong>{resultados.length}</strong> ausencias.</p>

          {/* Tabla de resumen */}
          <div className="overflow-auto mb-8 mt-6">
            <h2 className="text-md font-semibold mb-2">Resumen agrupado:</h2>
            <table className="w-full border text-sm">
              <thead>
                <tr className="bg-blue-50">
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResumen('Cantidad')}>Cantidad</th>
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResumen('Promoción')}>Promoción</th>
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResumen('Sede')}>Sede</th>
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResumen('Día')}>Día</th>
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResumen('Fecha')}>Fecha</th>
                </tr>
              </thead>
              <tbody>
                {resumenTabla.map((r, idx) => (
                  <tr key={idx} className="hover:bg-gray-100">
                    <td className="border p-2 text-center">{r.Cantidad}</td>
                    <td className="border p-2">{r.Promoción}</td>
                    <td className="border p-2">{r.Sede}</td>
                    <td className="border p-2">{r.Día}</td>
                    <td className="border p-2">{r.Fecha}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Tabla de ausencias */}
          <div className="overflow-auto mt-2">
            <table className="w-full border text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2">#</th>
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('cadeteDni')}>DNI</th>
                  <th className="border p-2 cursor-pointer hidden md:table-cell" onClick={() => ordenarResultados('apellido')}>Apellido</th>
                  <th className="border p-2 cursor-pointer hidden md:table-cell" onClick={() => ordenarResultados('nombre')}>Nombre</th>
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('sede')}>Sede</th>
                  <th className="border p-2 cursor-pointer hidden md:table-cell" onClick={() => ordenarResultados('promocion')}>Promoción</th>
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('estado')}>Estado</th>
                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('fecha')}>Fecha</th>
                </tr>
              </thead>
              <tbody>
                {resultados.map((ausencia, idx) => (
                  <tr key={idx} onClick={() => abreDatas(ausencia.cadeteDni)}>
                    <td className="border p-2 text-center">{idx + 1}</td>
                    <td className="border p-2">{ausencia.cadeteDni}</td>
                    <td className="border p-2 hidden md:table-cell">{ausencia.cadete?.cadeteApellido}</td>
                    <td className="border p-2 hidden md:table-cell">{ausencia.cadete?.cadeteNombre}</td>
                    <td className="border p-2">{ausencia.cadete?.cadeteSede}</td>
                    <td className="border p-2 hidden md:table-cell">{ausencia.cadete?.Promocions[0]?.nombre}</td>
                    <td className="border p-2">{ausencia.estado}</td>
                    <td className="border p-2">{new Date(ausencia.fecha).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {!loading && resultados.length === 0 && (
        <p className="mt-4 text-gray-500">No se encontraron resultados.</p>
      )}</>:""}

    </div>
  );
};

export default InformeAusencias;

